import GroupButton from "./GroupButton";
import { colorsList } from "../../data/colorsList";

export default function GroupsButtonsList({
  groupScreen,
  closeGroupScreen,
  optionsButtons,
  terGroups,
  filterMap,
  filter,
}) {
  return (
    <div
      style={{
        position: "absolute",
        right: 0,
        top: 0,
        height: "100%",
        width: groupScreen ? "100%" : "0%",
        overflow: "hidden",
        overflowY: "auto",
        transition: "width 0.2s ease-in-out",
        background: "linear-gradient(to left, white 0%, transparent 50%)",
        zIndex: 1,
      }}
      onClick={closeGroupScreen}
    >
      {optionsButtons.map(
        (e, index) =>
          e && (
            <GroupButton
              key={index}
              label={e.label}
              onClick={e.onClick}
              color={e.color}
            />
          )
      )}
      {terGroups.map((o, index) => (
        <GroupButton
          key={index}
          label={o.name}
          onClick={() => filterMap({ group: index })}
          color={filter.group === index ? colorsList.blue : colorsList.darkGrey}
        />
      ))}
    </div>
  );
}
